<template>
  <div class="companywaybill2">
    <basic-container>
      <g-crud
        :tableOpt="tableOptions"
        :fetch-data="fetchTableData"
        table-height="600"
        :table-border="true"
      >
      <template v-slot:left-area>
          <div class="statistics">
              <i class="el-icon-info"></i>
              <label>搜索结果：</label
              ><span
                >{{ page.total
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>未交单：</label
              ><span
                >{{ statisForm.notGiveNo
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>已交单：</label
              ><span
                >{{ statisForm.haveGiveNo
                }}<span style="color: #313133; margin-left: 10px">;</span></span
              >
              <label>已取消：</label
              ><span
                >{{ statisForm.canceled
                }}<span style="color: #313133; margin-left: 10px">;</span>
              </span>
            </div>
      </template>
        <template v-slot:search-actions-center>
           <el-button
              size="small"
              v-if="permissions['chain:companywaybill:exc']"
              :loading="btnLoading"
              @click="exOutExcel"
            >
              导出
            </el-button>
            <el-button
              v-if="permissions['chain:companywaybill:downImg']"
              size="small"
              :loading="btnLoading"
              @click="exportWaybillImage"
            >
              导出运单图片
            </el-button>
            <el-button
              v-if="permissions['chain:companywaybill:downImg']"
              style="margin-right: 20px; margin-bottom: 0"
              size="small"
              @click="openUrl"
            >
              导出图片工具
            </el-button>
        </template>
        <template v-slot:action="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </g-crud>
    </basic-container>
  </div>
</template>

<script>
import { tableOptions } from "./companywaybill2.js";
import gCrud from "./components/gCrud.vue";
import {mapGetters} from 'vuex'
export default {
  data() {
    return {
      tableOptions,
      btnLoading:false,
      statisForm:{},
      page:{
        
      }
    };
  },
  computed:{
    ...mapGetters(["permissions"]),
  },
  components: {
    gCrud,
  },
  methods: {
     openUrl() {
      window.open(
        "https://jyb-app.obs.cn-south-1.myhuaweicloud.com:443/%E8%BF%90%E5%8D%95%E4%B8%8B%E8%BD%BD%E5%9B%BE%E7%89%87%E5%B7%A5%E5%85%B7.zip"
      );
    },
     exportWaybillImage() {
      this.$confirm("导出图片需要先下载旁边的导出图片工具,继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = Object.assign({}, this.paramsSearch);
          if (params) {
            if (params.hasOwnProperty("generationTime")) {
              params.generationTimeStart = params.generationTime[0];
              params.generationTimeEnd = params.generationTime[1];
              delete params.generationTime;
            }
            if (params.hasOwnProperty("inDatetime")) {
              params.inDatetimeStart = params.inDatetime[0];
              params.inDatetimeEnd = params.inDatetime[1];
              delete params.inDatetime;
            }
            if (params.hasOwnProperty("goTime")) {
              params.goDatetimeStart = params.goTime[0];
              params.goDatetimeEnd = params.goTime[1];
              delete params.goTime;
            }
            if (params.hasOwnProperty("completeTime")) {
              params.completeDatetimeStart = params.completeTime[0];
              params.completeDatetimeEnd = params.completeTime[1];
              delete params.completeTime;
            }
            if (params.hasOwnProperty("entranceDatetime")) {
              params.entranceDatetimeStart = params.entranceDatetime[0];
              params.entranceDatetimeEnd = params.entranceDatetime[1];
              delete params.entranceDatetime;
            }
            if (params.hasOwnProperty("goShiftTime")) {
              params.goShiftTimeStart = params.goShiftTime[0];
              params.goShiftTimeEnd = params.goShiftTime[1];
              delete params.goShiftTime;
            }
            params.projectInfoId =
              Array.isArray(params.projectInfoId) &&
              params.projectInfoId.length > 0
                ? params.projectInfoId.join(",")
                : params.projectInfoId || "";
          }
          for (const key in params) {
            if (key.includes("$") || params[key] == undefined) {
              delete params[key];
            }
          }
          let url = "/chain/excelExport/postCreateByCode";
          params.code = "CompanyWaybillImageExcelExport";
          this.btnLoading = true;
          exportOut(params, url, "运单图片", "post")
            .then((res) => {
              this.btnLoading = false;
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        })
        .catch(() => {});
    },
      exOutExcel() {
      let params = Object.assign({}, this.paramsSearch);

      console.log(params);
      if (params) {
        if (params.hasOwnProperty("generationTime")) {
          params.generationTimeStart = params.generationTime[0];
          params.generationTimeEnd = params.generationTime[1];
          delete params.generationTime;
        }
        if (params.hasOwnProperty("inDatetime")) {
          params.inDatetimeStart = params.inDatetime[0];
          params.inDatetimeEnd = params.inDatetime[1];
          delete params.inDatetime;
        }
        if (params.hasOwnProperty("goTime")) {
          params.goDatetimeStart = params.goTime[0];
          params.goDatetimeEnd = params.goTime[1];
          delete params.goTime;
        }
        if (params.hasOwnProperty("completeTime")) {
          params.completeDatetimeStart = params.completeTime[0];
          params.completeDatetimeEnd = params.completeTime[1];
          delete params.completeTime;
        }
        if (params.hasOwnProperty("entranceDatetime")) {
          params.entranceDatetimeStart = params.entranceDatetime[0];
          params.entranceDatetimeEnd = params.entranceDatetime[1];
          delete params.entranceDatetime;
        }

        if (params.hasOwnProperty("goShiftTime")) {
          params.goShiftTimeStart = params.goShiftTime[0];
          params.goShiftTimeEnd = params.goShiftTime[1];
          delete params.goShiftTime;
        }
        params.projectInfoId =
          Array.isArray(params.projectInfoId) && params.projectInfoId.length > 0
            ? params.projectInfoId.join(",")
            : params.projectInfoId || "";
      }
      for (const key in params) {
        if (key.includes("$") || params[key] == undefined) {
          delete params[key];
        }
      }
      params.code = "BuilderCompanyWaybillExcelExport";
      this.btnLoading = true;
      postCreateByCode(params)
        .then((res) => {
          this.btnLoading = false;
          // this.$message.success('操作123成功')
          this.$store.commit("SET_DOWN_EXCEL_SHOW", true);
        })
        .catch(() => {
          this.btnLoading = false;
          this.$message.error("导出失败");
        });
    },
    handleEdit() {},
    handleDelete() {},
    async fetchTableData(params) {
      console.log("请求参数:", params);
      return new Promise((resolve) => {
        setTimeout(() => {
          const data = [
            {
              id: 1,
              name: "张三",
              age: 25,
              gender: "male",
              createdAt: "2024-01-01",
            },
            {
              id: 2,
              name: "李四",
              age: 30,
              gender: "female",
              createdAt: "2024-02-01",
            },
          ];
          resolve({ data, total: 2 });
        }, 500);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 修复搜索区域样式 */
.companywaybill2 /deep/ .search-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 增加间距 */
}

.companywaybill2 /deep/ .search-item .el-form-item__label {
  width: 100px; /* 固定 label 宽度 */
  flex-shrink: 0; /* 防止 label 被压缩 */
  text-align: right;
  padding-right: 10px;
}

.companywaybill2 /deep/ .search-item .el-form-item__content {
  flex-grow: 1; /* 输入框/选择框自适应宽度 */
  min-width: 0; /* 防止内容溢出 */
}

/* 修复 date-picker 宽度 */
.companywaybill2 /deep/ .search-item .el-date-editor {
  width: 100%; /* 使 date-picker 宽度与 input 一致 */
}
.statistics {
  padding: 0 16px;
  border: 3px;
  line-height: 30px;
  height: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #313133;
  border: 1px solid #35b1ff;
  background: #e9f2ff;
  margin-right: 16px;
  span {
    color: #35b1ff;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  i {
    color: #35b1ff;
    margin-right: 9px;
  }
}
</style>